import {
  Alert,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useProjects } from '../api/hooks'
import { statusLabels } from '../api/types'
import SharedBadge from '../components/SharedBadge'
import { formatDate, formatEUR2, formatPct } from '../format'
import { useAmountsHidden } from '../privacy'

export default function ProjectsPage() {
  const { data, loading, error } = useProjects()
  useAmountsHidden()

  return (
    <Box>
      <Stack direction="row" sx={{ mb: 3, justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">Projets</Typography>
      </Stack>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {data && data.length === 0 && (
        <Card>
          <CardContent>
            <Typography sx={{ color: 'text.secondary' }}>
              Aucun projet. Ouvrez une simulation et cliquez sur « Créer un projet ».
            </Typography>
          </CardContent>
        </Card>
      )}

      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        }}
      >
        {data?.map((p) => (
          <Card key={p.id}>
            <CardActionArea component={RouterLink} to={`/projects/${p.id}`} sx={{ height: '100%' }}>
              <CardContent>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
                >
                  <Typography variant="h6" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                    {p.name}
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={0.5}
                    useFlexGap
                    sx={{ flexWrap: 'wrap', justifyContent: 'flex-end', flexShrink: 0 }}
                  >
                    <Chip size="small" label={statusLabels[p.status]} />
                    <SharedBadge
                      role={p.role}
                      ownerEmail={p.ownerEmail}
                      sharedWithOthers={p.sharedWithOthers}
                    />
                  </Stack>
                </Stack>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {formatDate(p.createdAt)}
                </Typography>
                {!p.isOwner && p.ownerEmail && (
                  <Typography variant="body2" sx={{ color: 'info.main', overflowWrap: 'anywhere' }}>
                    Partagé par {p.ownerEmail}
                  </Typography>
                )}
                {p.simulation ? (
                  <Stack sx={{ mt: 2 }} spacing={0.5}>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      Simulation : {p.simulation.name}
                    </Typography>
                    <Typography variant="body2">
                      {formatEUR2(p.simulation.results.monthlyCashFlow)}/mois ·{' '}
                      {formatPct(p.simulation.results.netYield)} net
                    </Typography>
                  </Stack>
                ) : (
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                    Sans simulation liée
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  )
}
